import { Serializer, UISerializableSwapRecord } from '@drift/common';
import { useComposedHistory } from './useComposedHistory';
import {
	ALWAYS_TRUE_FILTER,
	type HistoryTableUIProps,
} from './historyDataTypes';

export const useSwapsHistory =
	(): HistoryTableUIProps<UISerializableSwapRecord> => {
		const { historyData, executePageChange } = useComposedHistory(
			'swaps',
			Serializer.Deserialize.UISwapRecord
		);

		return {
			executePageChange,
			filterFn: ALWAYS_TRUE_FILTER,
			historyData,
		};
	};
